import { Model } from '../store/types/documentType';
import { MapActions, MapState } from '../store/types/map';
import { useStoreActions, useStoreState } from './store';

export const useDocumentTypeActions: MapActions<Model> = (mapActions) => useStoreActions((actions) => mapActions(actions.documentType));
export const useDocumentTypeState: MapState<Model> = (mapState) => useStoreState((state) => mapState(state.documentType));
